import { isEqualsIgnoringCase } from 'utils/stringUtils';

export const ROLE_FUNCTIONALITY_OPERATION_SEP = ':';

export const ROLE_FUNCTIONALITY_ADMIN = 'ADMIN';

export const ROLE_OPERATION_READ = 'READ';
export const ROLE_OPERATION_SAVE = 'SAVE';
export const ROLE_OPERATION_DELETE = 'DELETE';

/**
 * Checks if a user is authorized to call functionality/operation.
 * @param user the user
 * @param functionality the functionality
 * @param operation the operation
 * @returns {boolean} true is user is authorized
 */
export function isAuthorized(user, functionality, operation) {
  if (!user?.roles?.length > 0) {
    return false;
  }
  return user.roles.some((role) => {
    const elems = role.split(ROLE_FUNCTIONALITY_OPERATION_SEP);
    if (isEqualsIgnoringCase(elems[0], ROLE_FUNCTIONALITY_ADMIN)) {
      return isEqualsIgnoringCase(elems[1], operation);
    }
    return (
      isEqualsIgnoringCase(elems[0], functionality) && isEqualsIgnoringCase(elems[1], operation)
    );
  });
}
